import React from 'react';
import Navbar from './global-components/navbar-v3';
import PageHeader from './global-components/page-header';
import ProjectDetailsPage from './section-components/project-detail';
import Footer from './global-components/footer';

const PropertyDetails = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Project Ideation Details"  />
        <ProjectDetailsPage />
        <Footer />
    </div>
}

export default PropertyDetails

